
import webBrowser from './webBrowser.js'

const openBoard= function(app){
    app.directive("board", {
        mounted(el, binding) {//打开写字板
            let target=el;
            if(!target.addEventListener){
                target= el.querySelector("input");
            }

            //input 获取焦点打开写字板
            target.addEventListener("focus", ()=> {
                webBrowser.openInputBoard()
            });

            //input 获取焦点打开写字板
            target.addEventListener("focus", ()=> {
                webBrowser.openInputBoard()
            });

            let handleDisable=(event)=>{
                event.preventDefault(); // 阻止粘贴操作
                event.stopPropagation();
            }
            target.addEventListener("copy",handleDisable);
            target.addEventListener("cut",handleDisable);
            target.addEventListener("contextmenu",handleDisable);
        }
    })
}

const onceClick =(app)=> {
    app.directive("onceClick", {
        mounted(el, binding) {
            el.addEventListener('click', () => {
                if (el && !el.disabled) {
                    el.disabled = true
                    setTimeout(() => {
                        if(el){
                            el.disabled = false
                        }
                        
                    }, binding.value || 1000)
                }
            })
        }
    })
}

/**input 控制键盘默认英文 */
const boardEnglish= function(app){
    app.directive("modeEn", {
        mounted(el, binding) {//打开写字板
            let target=el;
            
            if(!target.addEventListener || target.nodeName!="INPUT"){
                target= el.querySelector("input");
            }
            if(target){
                el._binding=binding;
                let type=target.type;
                //input 获取焦点打开写字板
                target.addEventListener("click", ()=> {
                    if(!(el._binding?.value===false)){
                        target.type="tel";
                        setTimeout(()=>{
                            target.type=type;
                        },100)

                        webBrowser.keyUpper();
                    }
                });
                target.addEventListener("focus", ()=> {
                    if(!(el._binding?.value===false)){
                        target.type="tel";
                        setTimeout(()=>{
                            target.type=type;
                        },100)
                        webBrowser.keyUpper();
                    }
                });
                
            }
        },
        updated(el,binding){
            el._binding=binding;
        }
    })
}

const copyTextDirective=(()=>{
    /**选中文本 */
    function selectText(element) {
        element.style["user-select"]="text";
        element.style["-webkit-user-select"]="text";
        element.style["-webkit-touch-callout"]="text";

        if (document.body.createTextRange) {
            let range = document.body.createTextRange();
            range.moveToElementText(element);
            range.select();
        } else if (window.getSelection) {
            let selection = window.getSelection();
            let range = document.createRange();
            range.selectNodeContents(element);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
    /**复制 */
    function copy(text) {
        if (navigator.clipboard) {
            // clipboard api 复制
            navigator.clipboard.writeText(text);
        } else {
            var textarea = document.createElement('textarea');
            document.body.appendChild(textarea);
            // 隐藏此输入框
            textarea.style.position = 'fixed';
            textarea.style.clip = 'rect(0 0 0 0)';
            textarea.style.top = '10px';
            // 赋值
            textarea.value = text;
            // 选中
            textarea.select();
            // 复制
            document.execCommand('copy', true);
            // 移除输入框
            document.body.removeChild(textarea);
        }
    }
    let outTime,copy_success;
    function tipTxt(element){
        if(!copy_success){
            copy_success=document.createElement("div");
            copy_success.className="copy_success";
            copy_success.innerText="复制成功";
            document.body.appendChild(copy_success);
        }
        
        copy_success.style.display="";
        let rect=element.getBoundingClientRect();
        copy_success.style.top=(rect.top-40)+"px";

        let left=rect.left+rect.width/2-68/2;
        if(left>0){
            copy_success.style.left=left+"px";
        }else{
            copy_success.style.left=0;
        }
        if(outTime){
            clearTimeout(outTime);
        }
        outTime=setTimeout(()=>{
            copy_success.style.display="none";
            element.style["user-select"]="";
            element.style["-webkit-user-select"]="";
            element.style["-webkit-touch-callout"]="";
        },1500)
    }
    return {
        copyText(el){
            let target=el;
            if(!target.addEventListener){
                target=el.querySelector("div");
            }
            if(!target.isCopy){
                target.isCopy=true;
                target.addEventListener("click", (e)=> {
                    selectText(target);
                    copy(target.innerText||target.value);
                    tipTxt(target)
                });
            }
        }
    }
})();
/**复制文本 */
const copyText=function(app){
    app.directive("copyText", copyTextDirective.copyText)
}

/**防抖指令 多次点击 一定时间内只触发一次 */
const throttle=function(app){
    app.directive('throttle', {
        mounted(el, binding){
            let throttleTime = binding.value; // 防抖时间
            if (!throttleTime) { // 用户若不设置防抖时间，则默认2s
                throttleTime = 1000 * 2;
            }
            let cbFun;
            el.addEventListener('click', event => {
                if (!cbFun) { // 第一次执行
                    clearTimeout(cbFun);
                    cbFun = setTimeout(() => {
                        cbFun = null;
                    }, throttleTime);
                } else {
                    event && event.stopImmediatePropagation();//阻止后续监听触发
                }
            }, true);
        },
    });
}

/**监听扫了支付码 */
const scanPayCode=function(app){
    app.directive('scanPayCode', {
        mounted(el, binding){
            let barCode="";
            let lastTime = 0;
            //监听键盘按下事件
            el.addEventListener('keydown', (event) => {
                let key=event.key;
                if(key=="Process"){//中文
                    if(/(Digit)|(Key)|(Numpad)/.test(event.code)){//数字或字母
                        key=event.code.replace(/(Digit)|(Key)|(Numpad)/,"")
                    }
                }
                const currCode =key;
                const currTime = new Date().getTime();
                if (event.keyCode === 13 || event.key =='Enter') {
                    // 回车键处理（扫码枪通常以回车键结束输入）
                    console.log(barCode.length)
                    if (barCode.length >= 16) {
                        const middleValue =  barCode.trim() || ''; // 提取中间部分并去除前缀
                        //微信 开头数字范围为 10-15  18位纯数字   支付宝 开头数字范围为 25-30  16-24位纯数字
                        if (middleValue && (/^1[0-5]\d{16}$/.test(middleValue) || /^((2[5-9])|(30))\d{14,22}$/.test(middleValue))) {
                            const activeElement = document.activeElement;
                            if (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA'){//如果焦点是输入框
                                activeElement.value=(activeElement.value).replace(middleValue,"");//剔除扫码内容
                                activeElement.dispatchEvent(new Event("input",{data:'val',inputType:'insertText'}));
                            }
                            // 调用通过参数传递的方法
                            if (binding.value) {
                                binding.value(middleValue);
                            }
                        } 
                    }
                    // 清空缓存数据
                    barCode="";
                    lastTime = 0;
                } else {
                    // 非回车键处理（收集扫码内容）
                    if (currCode?.length==1 &&  (lastTime === 0 || currTime - lastTime <= 300)) {
                        barCode += ""+currCode; // 拼接字符串
                        lastTime = currTime; // 更新最后输入时间
                    } else {// 超时清空数据
                        barCode="";
                        lastTime = 0;
                    }
                }
            });
        },
    });
}

/**监听读卡 */
const readCard=function(app){
    app.directive('readCard', {
        mounted(el, binding){
            let barCode="";
            let lastTime = 0;
            let codeLeng=binding.value||13;
            //监听键盘按下事件
            el.addEventListener('keydown', (event) => {
                const currCode = event.key || event.keyCode;
                const currTime = new Date().getTime();

                if (currCode === 13 || currCode =='Enter') {
                    // 回车键处理（扫码枪通常以回车键结束输入）
                    if (barCode.length >= codeLeng) {
                        const middleValue =  barCode.trim() || ''; // 提取中间部分并去除前缀
                        //binding.value(middleValue);
                        if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA'){//如果是输入框
                            el.value=(el.value).replace(middleValue,"");//剔除扫码内容
                            el.dispatchEvent(new Event("input",{data:'val',inputType:'insertText'}));
                        }
                        //el.dispatchEvent(new Event("input",{data:'val',inputType:'insertText'}));
                        el.dispatchEvent(new CustomEvent("barcode",{detail:middleValue}));
                    }
                    // 清空缓存数据
                    barCode="";
                    lastTime = 0;
                } else {
                    // 非回车键处理（收集扫码内容）
                    if (lastTime === 0 || currTime - lastTime <= 80) {
                        barCode += ""+currCode; // 拼接字符串
                        lastTime = currTime; // 更新最后输入时间
                    } else {// 超时清空数据
                        barCode="";
                        lastTime = 0;
                    }
                }
            });
        },
    });
}

/**长按事件 */
const longpress= function(app){
    app.directive("longpress", {
        mounted(el, binding) {
            if (typeof binding.value !== 'function') {
                console.warn('v-longpress指令必须绑定函数');
                return;
            }
        
            let pressTimer = null
            const duration = parseInt(binding.arg) || 5000 // 默认5秒触发
        
            const start = (e) => {
                if (e.type === 'click' && e.button !== 0) return
                
                if (pressTimer === null) {
                    pressTimer = setTimeout(() => {
                        binding.value(e)
                        pressTimer = null
                    }, duration);
                }
            }
        
            const cancel = () => {
                if (pressTimer !== null) {
                    clearTimeout(pressTimer)
                    pressTimer = null
                }
            }
        
            el._longpressHandlers = { start, cancel }
        
            // 添加事件监听
            el.addEventListener('mousedown', start)
            el.addEventListener('touchstart', start)
            el.addEventListener('click', cancel)
            el.addEventListener('mouseup', cancel)
            el.addEventListener('mouseleave', cancel)
            el.addEventListener('touchend', cancel)
            el.addEventListener('touchcancel', cancel)
        },
        unmounted(el) {
            // 移除事件监听
            if (el._longpressHandlers) {
                const { start, cancel } = el._longpressHandlers
                el.removeEventListener('mousedown', start)
                el.removeEventListener('touchstart', start)
                el.removeEventListener('click', cancel)
                el.removeEventListener('mouseup', cancel)
                el.removeEventListener('mouseleave', cancel)
                el.removeEventListener('touchend', cancel)
                el.removeEventListener('touchcancel', cancel)
            }
        }
    })
}
export {
    copyTextDirective
}

export default {
    install(app){
        app.use(openBoard);
        app.use(boardEnglish);
        app.use(copyText);
        app.use(throttle);
        app.use(scanPayCode);
        app.use(readCard);
        app.use(longpress);
        app.use(onceClick);
    }
}
